import React, { Component } from 'react';
import AvatarEditor from 'react-avatar-editor';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import * as actions from '../../actions/actions.jsx';
import defaultImage from '../../images/default.gif';
import services from '../../services/allservices.jsx';
import Loader from '../loader/loader.jsx';
import { getClientId, getClientSecret,buildClientHeader } from '../../utils/clientAuth.js'

const mapStateToProps = state =>
({
    publicKey: state.publicKey.publicKey,
    profileState: state.getProfileReducer.profileState,
})
const mapDispatchToProps = dispatch =>
({
    fetchProfileState(history) {
        dispatch(
            actions.getProfileAction(history)
        )
    }
})

class ProfileUpdateModal extends Component {
    state = {
        allowZoomOut: false,
        position: { x: 0.5, y: 0.5 },
        scale: 1,
        rotate: 0,
        images: '',
        borderRadius: 0,
        preview: null,
        width: 150,
        height: 150,
        fileSize: 0,
        image: '',
        fileType: '',
        fileLength: '',
        loader: false,
        size: 0,
        btn: true
    }
    componentDidMount() {
        // document.getElementById('showfileerror').style.display = "none"
    }

    handleNewImage = e => {
        this.setState({ image: e.target.files[0], size: (e.target.files[0].size), fileSize: this.bytesToSize(e.target.files[0].size), fileType: e.target.files[0].type, fileLength: e.target.files[0].size }
        , () => {
            console.log( "Image : "  , this.state.image)
            if ( this.state.image && this.state.image.size > 3145728) {
                this.setState({
                    btn: true
                })
                // document.getElementById('showfileerror').style.display = "block"
            }
            else {
                this.setState({
                    btn: false
                })
            }
        })
    }
    converturl = () => {

    }
    handlclose = () => {
        // document.getElementById('showfileerror').style.display = "none"
        this.setState({
            image: this.converturl()
        }
        )

    }
    bytesToSize(bytes) {
        var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
        if (bytes === 0) return '0 Byte';
        var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
        return Math.round(bytes / Math.pow(1024, i), 2)  + sizes[i];
        //return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
    }
    handleSave = data => {
        console.log("File Size :" , this.state.fileLength);
        if (this.state.fileLength <= 3145728 ) {
            const img = this.editor.getImageScaledToCanvas().toDataURL()
            const rect = this.editor.getCroppingRect()
            var str = img;

            var str_array = str.split(',');

            for (var i = 0; i < str_array.length; i++) {
                // Trim the excess whitespace.
                str_array[i] = str_array[i].replace(/^\s*/, "").replace(/\s*$/, "");

                // Add additional code here, such as:
            }
            this.setState({
                loader: true
            })
            this.setState({
                preview: {
                    img,
                    rect,
                    scale: this.state.scale,
                    width: this.state.width,
                    height: this.state.height,
                    borderRadius: this.state.borderRadius
                }
            })
            let state = {
                mediaInfo: str_array[1],
                mediaType: this.state.fileType,
                memberId: localStorage.getItem('memberId'),
                pictureId: this.state.pictureId
            }

            let token = "Token " + localStorage.getItem('token')
            let _this = this
            let plink =  localStorage.getItem('pform')==='AU'? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ 
              let traceId = getClientId();
            fetch(plink + services.profileimg , {
                method: 'POST',
                headers: new Headers({
                    'Content-Type': 'application/json',
                     'Authorization': token,
                      'X-Trace-Id': traceId ,
                      'X-Client-APP':buildClientHeader(),
                }),
                body: JSON.stringify(state)
            })
                .then(
                    function (response) {
                        if (response.status === 500) {
                            _this.setState({
                                loader: false
                            })
                            toast.error(response.headers.get('message'), {
                                position: "top-right",
                                draggablePercent: 60,
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: false
                            });
                        } else if (response.status === 200) {
                            _this.setState({
                                loader: false,
                            })
                            // hide modal without jquery first the Dialog and than backdrop shadow
                            document.getElementById('dpupdate').classList.remove('show');
                            document.getElementById('dpupdate').classList.add('hide');
                            let elements = document.querySelectorAll(".modal-backdrop");
                            [].forEach.call(elements, function(el){
                                el.className = el.className.replace(/\bshow/,"");
                            })

                            toast.success(response.headers.get('message'), {
                                position: "top-right",
                                draggablePercent: 60,
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: false
                            });

                            _this.props.fetchProfileState(this.props.history)();

                        }
                    })
        } else {
            this.setState({
                loader: false
            })
            toast.error('Please Upload Image Less Than 3 MB', {
                position: "top-right",
                draggablePercent: 60,
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false
            });

        }

    }

    handleScale = e => {
        const scale = parseFloat(e.target.value)
        this.setState({ scale })
    }

    handleAllowZoomOut = ({ target: { checked: allowZoomOut } }) => {
        this.setState({ allowZoomOut })
    }

    rotateLeft = e => {
        e.preventDefault()

        this.setState({
            rotate: this.state.rotate - 90
        })
    }

    rotateRight = e => {
        e.preventDefault()
        this.setState({
            rotate: this.state.rotate + 90
        })
    }

    handleBorderRadius = e => {
        const borderRadius = parseInt(e.target.value, 10)
        this.setState({ borderRadius })
    }

    handleXPosition = e => {
        const x = parseFloat(e.target.value)
        this.setState({ position: { ...this.state.position, x } })
    }

    handleYPosition = e => {
        const y = parseFloat(e.target.value)
        this.setState({ position: { ...this.state.position, y } })
    }

    handleWidth = e => {
        const width = parseInt(e.target.value, 10)
        this.setState({ width })
    }

    handleHeight = e => {
        const height = parseInt(e.target.value, 10)
        this.setState({ height })
    }

    logCallback(e) {

    }
    checkObject(obj) {
        for (var prop in obj) {
            if (obj.hasOwnProperty(prop)) {
                return true;
            } else {
                return false
            }

        }
    }
    setEditorRef = editor => {
        if (editor) this.editor = editor
    }

    handlePositionChange = position => {
        this.setState({ position })
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.profileState.body.profilePicture !== null) {
            this.setState({
                mediaInfo: nextProps.profileState.body.profilePicture.mediaInfo,
                pictureId: nextProps.profileState.body.profilePicture.pictureId
            })
        }



    }
    render() {
        const { fileSize, mediaInfo, size } = this.state
        return (
            <div className="modal fade" id="dpupdate" role="dialog">

                <div className="modal-dialog">

                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">Update Profile Picture</h4>
                            <button type="button" className="close" data-dismiss="modal">&times;</button>
                        </div>
                        {this.state.loader && <div style={{ marginTop: "200px" }}><Loader /></div>}
                        <div className="modal-body">
                            <div className="col-sm-12 text-center" >
                                <AvatarEditor
                                    ref={this.setEditorRef}
                                    scale={parseFloat(this.state.scale)}
                                    width={this.state.width}
                                    height={this.state.height}
                                    position={this.state.position}
                                    onPositionChange={this.handlePositionChange}
                                    rotate={parseFloat(this.state.rotate)}
                                    borderRadius={this.state.borderRadius}
                                    onSave={this.handleSave}
                                    onLoadFailure={this.logCallback.bind(this, 'onLoadFailed')}
                                    onLoadSuccess={this.logCallback.bind(this, 'onLoadSuccess')}
                                    onImageReady={this.logCallback.bind(this, 'onImageReady')}
                                    onImageLoad={this.logCallback.bind(this, 'onImageLoad')}
                                    onDropFile={this.logCallback.bind(this, 'onDropFile')}
                                    image={this.state.image || "data:image/jpeg;base64," + mediaInfo || defaultImage}
                                />
                                <br />
                                <div>
                                    <input type="file" name="file-1[]" id="file-1" className="inputfile inputfile-1" data-multiple-caption="{count} files selected" multiple
                                        style={{ display: "none" }} onChange={this.handleNewImage.bind(this)} onClick={(event) => { event.target.value = null }} />
                                    <label htmlFor="file-1"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="17" viewBox="0 0 20 17"><path d="M10 0l-5.2 4.9h3.3v5.1h3.8v-5.1h3.3l-5.2-4.9zm9.3 11.5l-3.2-2.1h-2l3.4 2.6h-3.5c-.1 0-.2.1-.2.1l-.8 2.3h-6l-.8-2.2c-.1-.1-.1-.2-.2-.2h-3.6l3.4-2.6h-2l-3.2 2.1c-.4.3-.7 1-.6 1.5l.6 3.1c.1.5.7.9 1.2.9h16.3c.6 0 1.1-.4 1.3-.9l.6-3.1c.1-.5-.2-1.2-.7-1.5z" /></svg> <span style={{ cursor: "pointer" }}><a href>Choose a file&hellip;</a></span> </label>
                                    <br />
                                </div>
                                <div>
                                    <input
                                        name='scale'
                                        type='range'
                                        onChange={this.handleScale}
                                        min={this.state.allowZoomOut ? '0' : '1'}
                                        max='2'
                                        step='0.01'
                                        defaultValue='1'
                                    />
                                </div>
                                {(size > 3145728) &&
                                    <div><span style={{ color: 'red' }}>File size is: {fileSize}, please upload image size of less than 3MB</span></div>}
                                {/* <input type='button'  value='Preview' /> */}
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-std" disabled={this.state.btn} onClick={this.handleSave}>Save</button>
                            <button type="button" className="btn btn-std" onClick={this.handlclose} data-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProfileUpdateModal);


// WEBPACK FOOTER //
// ./src/components/myprofile/profileupdate.jsx